import React from 'react';
import { VStack, HStack, Modal, Box } from 'native-base';
import { H4, Caption } from '~/shared/Typography';
import { Button } from '~/shared/Theme';
import { SpIcon } from '~/shared/Icon';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '@springbig/shared';
import { PassKeyIcon } from './PassKeyIcon';

type PasskeyPromptProps = {
  isOpen: boolean;
  onClose: () => void;
  onCreatePasskey: () => void;
  onRemindLater: () => void;
};

export const PasskeyPrompt = ({
    isOpen,
    onClose,
    onCreatePasskey,
    onRemindLater,
}: PasskeyPromptProps) => {

    const {
        modal,
        modal_text,
        button_text
    } = useTheme();

    return (
        <Modal position={'absolute'} bottom={0} isOpen={isOpen} onClose={onClose} avoidKeyboard alignSelf={'center'} justifyContent="flex-end" bg={modal} w={'clamp(320px, 100vw, 480px)'} h={'268px'} color={modal_text} borderTopRadius={'xl'}>
            <VStack space={4} alignItems="center"  w={'clamp(320px, 100vw, 480px)'} p={8} >
                <VStack space={2} w="100%">
                    <H4 text='passkey_prompt.title' />
                    <Caption text='passkey_prompt.description' />
                </VStack>

                <Button
                    onPress={onCreatePasskey}
                    w={'100%'}
                    mx={'auto'}
                >
                    <HStack flex={1} mx={'auto'} space={2} pt={2}>
                        <Box pt={0.5}>
                            <PassKeyIcon />
                        </Box>
                        <Caption color={button_text} text='passkey_prompt.button' />
                    </HStack>
                </Button>

                <Button onPress={onRemindLater} variant='text'>
                    <Caption text={'passkey_prompt.remind_later'} />
                </Button>
            </VStack>
        </Modal>
    );
};
